import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Avatar from '../../Account/Profile/Avatar';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { colors } from '../../../constants/colors';
import { fontFamily, fontSize } from '../../../constants/text';

const StyledListItem = styled(ListItem)`
  & .listItemRoot {
  }
`;

const UnverifiedPrimary = styled.span`
  font-style: italic;
`;

const Name = styled.span`
  color: ${colors.myRightFoot};
  font-family: ${fontFamily.medium};
`;

const Secondary = styled.span`
  color: ${colors.lightText};
  text-transform: capitalize;
  font-size: ${fontSize.mediumSmall};
`;

const TrashCan = styled(DeleteIcon)`
  &.secondary {
    color: ${colors.lightText};
  }
`;

class ProfileListRow extends PureComponent {
  static propTypes = {
    openDeleteProfile: PropTypes.func,
    isVerified: PropTypes.bool,
    profileColor: PropTypes.string,
    relationshipToAccount: PropTypes.string,
    showTrashCan: PropTypes.bool,
    userProfile: PropTypes.object,
  };

  handleDeleteClick = e => {
    e && e.stopPropagation();
    this.props.openDeleteProfile(this.props.userProfile);
  };

  render() {
    const { isVerified, profileColor, relationshipToAccount, userProfile } = this.props;
    return (
      <StyledListItem button classes={{ root: 'listItemRoot' }}>
        <Avatar userProfile={userProfile} profileColor={profileColor} />
        <ListItemText
          primary={
            isVerified ? (
              <Name>
                {userProfile.first_name} {userProfile.last_name}
              </Name>
            ) : (
              <UnverifiedPrimary>Unverified Profile</UnverifiedPrimary>
            )
          }
          secondary={<Secondary>{relationshipToAccount}</Secondary>}
        />
        {this.props.showTrashCan && (
          <ListItemSecondaryAction>
            <IconButton aria-label="Delete" onClick={this.handleDeleteClick}>
              <TrashCan color="secondary" classes={{ colorSecondary: 'secondary' }} />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </StyledListItem>
    );
  }
}

export default ProfileListRow;
